export const en = {
  archive: 'archive',
  items: 'items',
  itemsTable: 'items table',
  tag: 'tag',
  tags: 'tags',
  editItem: 'edit item',
  addItem: 'add new item',
  total_items: 'total items',
  active_items: 'active items',
  active: 'active',
  inactive_items: 'inactive items',
  category_name: 'Category Name',
  item_details: 'Item Details',
  min_input_2: 'this input length must be more than 2',
  max_input_150: 'this input length must be less than 150',
  todoItems: 'to-do items',
  uploadedReports: 'uploaded reports',
  uploadedFiles: 'uploaded files',
  country: 'country',
  search_by_country: 'search by country name',
  top_used_tags: 'top used tags',
  itemsCategory: 'items / category',
  items_groups: 'items / group',
  categories: 'categories',
  versions: 'versions',
  reportedBy: 'reported by',
  file_type: 'file type',
  file_count: 'no. of files',
  repeated_items: 'repeated items',
  information: 'information',
  last_update: 'last update',
  last_update_by: 'last update by',
  report_name: 'report name',
  sentiment: 'sentiment',
  version: 'versions',
  Versions_num: 'versions',
  frequency: 'frequency',
  item: 'item',
  upload_your_file: 'upload your file',
  upload: 'upload',
  add_new_report: 'add new report',
  related_items: 'related items',
  search_by_tags: 'search by tags',
  related_items_search: 'Search to add a related item',
  add_tags_search: 'Search to add a tag',
  add_groups_search: 'Search to add a group',
  add_categories_search: 'Search to add a category',
  are_you_sure_you_want_to_cancel_edit_item:
    'Are you sure you want to cancel editing item ?',
  are_you_sure_you_want_to_cancel_add_item:
    'Are you sure you want to cancel adding item ?',
  added_successfully: 'item added successfully',
  edited_successfully: 'item edited successfully',
  follow: 'follow',
  un_follow: 'un_follow',
  uploaded_files: 'Uploaded files',
  file_size_is_too_large: 'upload file size must be less than 150MB',
  clone_report: 'clone report',
  creation_date: 'creation date',
  clone_and_replace: 'clone type',
  clone_replace_report: 'clone & replace report',
  only_clone: 'clone only ',
  edit_report: 'edit report',
  please_note_that_uploading_new_files:
    'Please Note that uploading new files will replace the current uploaded files of the cloned report',
  clone: 'clone',
};
export const ar = {
  clone: 'استنساخ',
  please_note_that_uploading_new_files:
    'بالرجاء العلم ان تحميل المزيد من الملفات لهذا التقرير سيقوم بإستبدال الملفات المحملة مسبقاً',
  edit_report: 'تعديل التقرير',
  creation_date: 'تاريخ الإنشاء',
  clone_and_replace: 'نوع الاستنساخ ',
  clone_replace_report: 'استنساخ واستبدال التقرير',
  only_clone: 'استنساخ فقط',
  clone_report: 'استنساخ التقرير',
  archive: 'الأرشيف',
  items: 'العناصر',
  itemsTable: 'جدول العناصر',
  tag: 'الكلمة مفتاحية',
  tags: 'الكلمات المفتاحية',
  editItem: 'تعديل عنصر',
  addItem: 'اضافة عنصر جديد',
  total_items: 'كل العناصر',
  active_items: 'العناصر الفعالة',
  country: 'الدولة',
  search_by_country: 'إبحث بإسم الدولة',
  active: 'مفعل',
  category_name: 'اسم الفئة',
  file_type: 'نوع الملف',
  file_count: 'عدد الملفات',
  min_input_2: 'يجب ان يكون عدد الاحرف علي الاقل 2',
  max_input_150: 'يجب ان يكون عدد الاحرف لا يزيد عن 150',
  inactive_items: 'العناصر غير الفعالة',
  uploadedReports: 'تقارير مرفوعة',
  uploadedFiles: 'الملفات المحملة',
  top_used_tags: 'الكلمات المفتاحية الاكثر استخداما',
  todoItems: 'المهام',
  reportedBy: 'تم التحميل بواسطة',
  itemsCategory: 'العناصر / الفئة',
  items_groups: 'العناصر/المجموعه',
  search_by_tags: 'البحث بواسطة الكلمات المفتاحية',
  information: 'المعلومات',
  categories: 'الفئات',
  last_update: 'اخر تحديث',
  last_update_by: 'اخر تحديث بواسطة',
  item_details: 'تفاصيل العنصر',
  versions: 'الملفات',
  repeated_items: 'العناصر المتكرره',
  report_name: 'اسم التقرير',
  sentiment: 'الرأي',
  version: 'الملف',
  frequency: 'التكرار',
  item: 'العنصر',
  upload_your_file: ' تحميل الملف الخاص بك',
  add_new_report: 'إضافة تقرير جديد',
  upload: 'تحميل',
  versions: 'الإصدارات',
  related_items: 'العناصر المرتبطة',
  related_items_search: 'البحث لأضافة عنصر مرتبط',
  add_tags_search: 'البحث لأضافة كلمة مفتاحية',
  add_groups_search: 'البحث لأضافة مجموعه',
  Versions_num: 'عدد النسخ',
  add_categories_search: 'البحث لأضافة فئة',
  are_you_sure_you_want_to_cancel_edit_item:
    'هل انت متأكد انك تريد الغاء تعديل العنصر؟',
  are_you_sure_you_want_to_cancel_add_item:
    'هل انت متأكد انك تريد الغاء اضافة العنصر؟',
  added_successfully: 'تم إضافة العنصر بنجاح',
  edited_successfully: 'تم تعديل العنصر بنجاح',
  follow: 'اتبع',
  un_follow: 'إلغاء المتابعة',
  uploaded_files: 'الملفات المحمّلة',
  file_size_is_too_large: 'يجب ان يكون حجم الملف اقل من 150 ميجا بايت',
};
